module.exports = __webpack_public_path__ + "static/media/profile-2015.e4d1b43c.jpg";